// Plugin to install payment gateway globally in vue
import { PaymentGateway } from "./main";

export const PaymentGatewayPlugin = {
  install(Vue, options) {
    Vue.PaymentGateway = new PaymentGateway(options.config);
  }
};
